import api from 'shared/api'

export const leaveGroup = async ({ accessToken, groupId }) => {
  const { data } = await api.post(`/groups/${groupId}/leave`, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return data
}

export const joinGroup = async ({ accessToken, groupId }) => {
  const { data } = await api.post(`/groups/${groupId}/join`, null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return data
}

export const doLoadFeed = async ({ page, accessToken, groupId }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/public/groups/${groupId}/feed?page=${page}&limit=20`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })

  return { list, total }
}

export const doLoadArticles = async ({ page, accessToken, groupId }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(
    `/public/articles/feed?page=${page}&limit=20&group=${groupId}&type=Latest`,
    {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
  )

  return { list, total }
}

export const doLoadQuestions = async ({ page, accessToken, groupId }) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(
    `/public/questions/feed?page=${page}&limit=20&group=${groupId}&type=Latest`,
    {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
  )

  return { list, total }
}

export const doLoadMembers = async ({
  page,
  limit = 20,
  accessToken,
  groupId,
}) => {
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(
    `/public/groups/${groupId}/members?page=${page}&limit=${limit}`,
    {
      headers: { Authorization: `Bearer ${accessToken}` },
    }
  )

  return { list, total }
}

export const approveMember = async ({ accessToken, groupId, userId }) => {
  const { data } = await api.post(
    `/groups/${groupId}/approve`,
    { userId },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )

  return data
}

export const kickMember = async ({ accessToken, groupId, userId }) => {
  const { data } = await api.post(
    `/groups/${groupId}/kick`,
    { userId },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )

  return data
}
